export enum CallStatusType {
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  ENDED = 'ended',
  FAILED = 'failed',
}

export const STATUS_TEXTS = {
  [CallStatusType.CONNECTING]: 'Connecting...',
  [CallStatusType.ENDED]: 'Call Ended',
  [CallStatusType.FAILED]: 'Failed',
} as const;

export type CallStatus = typeof CallStatusType[keyof typeof CallStatusType];

export enum MicrophonePermission {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt'
}
